/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */
import { createReducer, createAction } from '@reduxjs/toolkit';
import { bindActionCreators } from 'redux';
import { GetUserDataInterface, GetUserB2BDataInterface } from '@/types';

export interface CredentialInitialState {
  userData: GetUserDataInterface | GetUserB2BDataInterface;
}

export const initialState: CredentialInitialState = {
  userData: {} as GetUserDataInterface | GetUserB2BDataInterface,
};

const STORE_USER_DATA = 'STORE_AUTH_TOKEN';

export const getUserData: (
  state: any
) => GetUserDataInterface | GetUserB2BDataInterface = (state: any) =>
  state.userData;

export const storeUserData = createAction(
  STORE_USER_DATA,
  (payload: GetUserDataInterface | GetUserB2BDataInterface) => ({
    payload: {
      ...payload,
    },
  })
);

export function mapDispatchToProps(dispatch: any) {
  return bindActionCreators({ storeUserData }, dispatch);
}

export function mapStateToProps(state: any) {
  return {
    userData: getUserData(state.credentials),
  };
}

export default createReducer(initialState, {
  [STORE_USER_DATA]: (state, action) => {
    state.userData = action.payload;
  },
});
